export type AppCategory = "AI Tools" | "Career" | "Travel" | "Creative" | "Productivity";

export type AppEntry = {
  slug: string;
  name: string;
  tagline: string;
  description: string;
  href: string;
  category: AppCategory;
  icon: "grid" | "spark" | "doc" | "mic" | "map" | "pin" | "brush" | "mail";
};

export const APP_CATEGORIES: AppCategory[] = ["AI Tools", "Career", "Travel", "Creative", "Productivity"];

export const APPS: AppEntry[] = [
  {
    slug: "resumes",
    name: "Nohaya Resumes",
    tagline: "Resume Builder & Samples",
    description:
      "Browse thousands of real resume examples across every career field, then customize one for your own job search with the built-in visual resume editor — key skills, action verbs and writing tips included for every role.",
    href: "/resumes",
    category: "Career",
    icon: "doc",
  },
  {
    slug: "prompts",
    name: "PromptAi",
    tagline: "AI Image Prompts",
    description:
      "Browse 100+ free AI image prompts — cinematic portraits, posters, edits and more. Copy any prompt to use in ChatGPT, or get the PromptAi app to run it on your own photos.",
    href: "/prompts",
    category: "AI Tools",
    icon: "spark",
  },
  {
    slug: "ai-tools",
    name: "Nohaya AI Tools",
    tagline: "AI Assistants",
    description:
      "Smart AI tools to simplify your work and life: writing assistants, image generation, voice and video tools, code helpers and business assistants, all in one place.",
    href: "/ai-tools",
    category: "AI Tools",
    icon: "spark",
  },
  {
    slug: "voice-tools",
    name: "Nohaya Voice",
    tagline: "AI Voice Tools",
    description:
      "Create, convert and enhance voice with AI — text-to-speech, speech-to-text, voice changer, voice cloning and audio enhancement for creators, podcasters and developers.",
    href: "/voice-tools",
    category: "AI Tools",
    icon: "mic",
  },
  {
    slug: "places",
    name: "Nohaya Travel",
    tagline: "Travel Guides & Maps",
    description:
      "Travel guides, local tips and smart maps to explore the world — discover places, restaurants and attractions recommended by people who've actually been there.",
    href: "/places",
    category: "Travel",
    icon: "map",
  },
  {
    slug: "local-guides",
    name: "Nohaya Local Guides",
    tagline: "Local Recommendations",
    description:
      "Find the best local spots, restaurants, cafes and hidden gems recommended by locals — useful whether you're a visitor or just exploring your own city.",
    href: "/local-guides",
    category: "Travel",
    icon: "pin",
  },
  {
    slug: "add-place",
    name: "Add a Place",
    tagline: "Contribute a Recommendation",
    description:
      "Help others discover great places by adding your own recommendations to Nohaya Travel — share the spots you'd actually tell a friend about.",
    href: "/add-place",
    category: "Travel",
    icon: "pin",
  },
  {
    slug: "email-cleaner",
    name: "Email Cleaner",
    tagline: "AI Inbox Cleanup",
    description:
      "Connect your Gmail and let AI clean up your inbox — smart cleanup suggestions, priority ranking, subscription tracking, spending insights, automation rules and an AI assistant for your mail, powered by the same backend as the Maila app.",
    href: "/email-cleaner",
    category: "Productivity",
    icon: "mail",
  },
  {
    slug: "creators",
    name: "Nohaya Creator Hub",
    tagline: "Tools for Creators",
    description:
      "Tools and resources to help creators build and grow: content idea generators, a script writer, hashtag finder and channel analyzer for every platform.",
    href: "/creators",
    category: "Creative",
    icon: "brush",
  },
];
